'use client';
import { ControlledInput } from 'components';
import useOptionsClients from 'hooks/useOptionsClients';
import useOptionsPairLanguages from 'hooks/useOptionsPairLanguages';
import useOptionsPoCode from 'hooks/useOptionsPoCode';
import useOptionsQuality from 'hooks/useOptionsQuality';
import useOptionsTransactionTypes from 'hooks/useOptionsTransactionTypes';
import { SearchIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { Control } from 'react-hook-form';
import { KeysEnum } from 'types/KeysEnum';
import { cn } from 'utils/cn';
import { FiltersTransactionForm } from '../_context/useSearchParamsTransactions';

interface IFiltersTransactions {
  control: Control<FiltersTransactionForm>;
  onClear?: () => void;
  filtersAdded?: boolean;
}

const FiltersTransactions: FC<IFiltersTransactions> = ({ control, filtersAdded, onClear }) => {
  const t = useTranslations();

  const { optionsClients } = useOptionsClients();
  const { optionsQuality } = useOptionsQuality();
  const { optionsLanguages } = useOptionsPairLanguages();
  const { optionsTransactionTypes } = useOptionsTransactionTypes();
  const { optionsPoCode } = useOptionsPoCode();

  return (
    <div
      className={cn(
        'relative grid w-full grid-cols-4 flex-wrap gap-4 gap-y-0 bg-tertiary-1000  p-4 !pt-0 pb-2',
        'border-0 border-b-1  border-tertiary-600'
      )}
    >
      <div>
        <ControlledInput
          control={control}
          label={t('billing.search')}
          placeholder={t('billing.search_placeholder')}
          type="text"
          name={KeysEnum.Query}
          className="!w-full"
          endAdornment={<SearchIcon />}
        />
      </div>
      <div>
        <ControlledInput
          control={control}
          label={t('billing.language_pair')}
          type="select"
          name={KeysEnum.Languages}
          options={optionsLanguages}
        />
      </div>
      <div>
        <ControlledInput
          control={control}
          type="date-range"
          name={KeysEnum.DateRange}
          label={t('billing.date_range')}
        />
      </div>
      <div>
        <ControlledInput
          control={control}
          label={t('billing.quality')}
          type="select"
          name={KeysEnum.Quality}
          options={optionsQuality}
        />
      </div>
      <div>
        <ControlledInput
          control={control}
          label={t('billing.transaction_type')}
          type="select"
          name={KeysEnum.TransactionType}
          options={optionsTransactionTypes}
        />
      </div>
      {optionsClients?.length > 2 && (
        <div>
          <ControlledInput
            control={control}
            label={t('billing.created_by_user')}
            type="select"
            name={KeysEnum.UserId}
            options={optionsClients}
          />
        </div>
      )}
      <div>
        <ControlledInput
          control={control}
          label={t('billing.invoice_id')}
          type="text"
          name={KeysEnum.InvoiceId}
          className="!w-full"
        />
      </div>
      <div>
        <ControlledInput
          control={control}
          label={t('billing.po_code')}
          type="select"
          name={KeysEnum.PoCode}
          options={optionsPoCode}
        />
      </div>
    </div>
  );
};
export default FiltersTransactions;
